/**
 * ImageBlock
 * @module components/ImageBlock
 */

import LazyLoad from 'react-lazyload';
import { Hightlight, ImageModel } from 'types/common';

import {
	BlockLink,
	ImageWrapper,
	Heading,
	Description,
	Text,
	Label,
	Image,
	PublishedDate,
	IconCircleBackground,
} from './ImageBlock.styles';
import { useSiteType } from 'context/siteType.context';
import Icon from 'components/ui/Icon';

interface ImageBlockProp {
	link: string;
	heading: string;
	shortDescription?: string;
	preamble: string;
	publishedDate?: string;
	headingSize?: string;
	image?: ImageModel;
	highlight?: Hightlight;
	renderArrowIcon?: boolean;
}

const ImageBlock = (block: ImageBlockProp) => {
	const {
		link,
		image,
		highlight,
		publishedDate,
		heading,
		shortDescription,
		preamble,
		headingSize,
		renderArrowIcon,
	} = block;
	const siteType = useSiteType();
	const isLindab = siteType === 'Lindab';
	return (
		<article>
			<BlockLink href={link}>
				<LazyLoad>
					<ImageWrapper>
						{image && (
							<picture>
								{image.webpSizes && (
									<source
										type="image/webp"
										srcSet={`${image.webpSizes[0]} 800w, ${image.webpSizes[1]} 400w`}
										sizes="(max-width: 767px) 70vw, (min-width: 768px) 5vw, 400px"
										className="rounded-card bg-white"
									/>
								)}
								{image.sizes && (
									<Image
										src={image.src}
										srcSet={`${image.sizes[0]} 800w, ${image.sizes[1]} 400w`}
										sizes="(max-width: 767px) 70vw, (min-width: 768px) 5vw, 400px"
										alt={image.alt ? image.alt : ''}
										className="rounded-card bg-white"
									/>
								)}
							</picture>
						)}
						{/* fix this hardcoded laveneder alter - abckend needs to send it from cms */}
						{highlight && (
							<Label color={isLindab ? 'lavender' : highlight.color} isLindab>
								{highlight.text}
							</Label>
						)}
						{isLindab && renderArrowIcon && (
							<>
								<IconCircleBackground />
								<Icon
									icon="arrow"
									size={2}
									className="absolute right-0 mr-1 bottom-3 text-blue"
								/>
							</>
						)}
					</ImageWrapper>
				</LazyLoad>
				<div>
					{publishedDate && (
						<PublishedDate isLindab>{publishedDate}</PublishedDate>
					)}
					{heading && (
						<Heading as="h2" size={headingSize} isLindab>
							{heading}
							{shortDescription && (
								<>
									<Description>{` - ${shortDescription}`}</Description>
								</>
							)}
						</Heading>
					)}
					{preamble && <Text>{preamble}</Text>}
				</div>
			</BlockLink>
		</article>
	);
};

export default ImageBlock;
